import React, { Component } from "react";
import axios from "axios";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import { CustomSpinner } from "../utils/CustomComponents";

export default class ConcreteSupplyPerformancePDF extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModalEmail: false,
			showModalSms: false,
			pdf: "",
			loading: true,
		};
	}

	/**
	 * Get PDF Inspection
	 */
	getPDFReport = async () => {
		const url =
			api +
			`/job/generate/57logistics/concretesupplyperformance/pdf/${this.props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);
			this.setState({
				pdf: data.payload,
				loading: false,
			});
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	/**
	 * Open and close email modal
	 * @param {Event} e event of the modal
	 */
	toggleModalEmail = (e) => {
		this.setState({
			showModalEmail: !this.state.showModalEmail,
		});
	};

	/**
	 * Open and close sms modal
	 * @param {Event} e event of the modal
	 */
	toggleModalSms = (e) => {
		this.setState({
			showModalSms: !this.state.showModalSms,
		});
	};

	componentDidMount() {
		this.getPDFReport();
	}

	render() {
		return (
			<Layout
				title="Concrete Supply Performance Report PDF"
				description="Report"
				className="container col-md-12"
			>
				{this.state.loading ? (
					<CustomSpinner />
				) : (
					<iframe src={this.state.pdf} width="95%" style={{ height: "90vh" }} />
				)}
			</Layout>
		);
	}
}
